<template>
  <div class="work">
    <!-- Loader -->
    <vue-element-loading
      :active="isGetWorkLoading"
      is-full-screen
      spinner="bar-fade-scale" />
    <!-- End Loader -->

    <!-- Work -->
    <v-container
      v-if="!isGetWorkLoading && ourWork && ourWork.fields"
      class="pa-0"
      style="max-width: 1000px;">
      <!-- Header -->
      <vue-headful :title="`${ourWork.fields['Name']} . ${ourWork.fields['Subtitle']} . Pixelsquad`" />
      <!-- End Header -->

      <section
        id="header"
        style="max-width: 800px;"
        class="my-5 py-5">
        <h1
          class="display-3 font-weight-black pa-5"
          :style="'color:' + ourWork.fields['Name Color']">
          {{ ourWork.fields['Name'] }}
        </h1>
        <h2 class="pa-5">
          {{ ourWork.fields['Subtitle'] }}
        </h2>
      </section>
      <template>
        <v-img
          v-if="ourWork.fields.Attachments"
          :eager="true"
          :src="ourWork.fields.Attachments[0].url"
          class="my-5 py-5" />
      </template>
      <section style="max-width: 800px; margin-bottom: 120px;">
        <h1 class="display-1 font-weight-black pa-5">
          {{ ourWork.fields['Headline'] }}
        </h1>
        <div
          class="pa-5"
          v-html="ourWork.fields['Body Text']" />
        <v-btn
          text
          class="font-weight-bold ml-2"
          :href="ourWork.fields['HyperLink']">
          {{ ourWork.fields['CTA Label'] }}
          <v-icon
            small
            class="ml-1">
            open_in_new
          </v-icon>
        </v-btn>
      </section>
      <template
        v-if="ourWork.fields.Attachments">
        <fade-in>
          <v-img
            v-for="(_attachment, index) in ourWork.fields.Attachments.slice(1)"
            :key="index"
            :eager="true"
            :src="_attachment.url" />
        </fade-in>
      </template>
    </v-container>
    <!-- End Work -->
  </div>
</template>

<script>
import VueElementLoading from 'vue-element-loading';
import axios from "axios";
// import _ from "lodash";
import qs from "qs";
import FadeIn from '../components/animation/FadeIn';

export default {
	name: "Work",

	components: {
		VueElementLoading,
		FadeIn
	},

	data() {
		return {
			apiUrl: this.$VUE_APP_AIRTABLE_URL,
			apiKey: this.$VUE_APP_AIRTABLE_API_KEY, // Always use a read-only account token
			apiBase: this.$VUE_APP_AIRTABLE_BASE,

			isGetWorkLoading: false,

			ourWork: {}
		};
	},

	//----------------------------
	// One thing to note when using routes with params is that when the user navigates
	// from /user/foo to /user/bar, the same component instance will be reused.
	// Since both routes render the same component, this is more efficient than destroying the old instance
	// and then creating a new one. However, this also means that the lifecycle hooks of the component will not be called.
	// watch: {
	// 	$route(to, from) {
	// 		console.log(from);
	// 		console.log(to);
	// 		// react to route changes...
	// 	}
	// },
	// beforeRouteUpdate (to, from, next) {
	// 	console.log(from);
	// 	console.log(to);
	// 	// react to route changes...
	// 	// don't forget to call next()
	// },
	//----------------------------

	mounted: function() {
		this.isGetWorkLoading = true;
		this.getWork();
	},

	methods: {
		getWork: function() {
			axios({
				url: this.apiUrl + this.apiBase + `/OurWork`,
				headers: {
					Authorization: `Bearer ${this.apiKey}`
				},
				params: {
					'filterByFormula': `({Slug}='${this.$route.params.slug}')`
				},
				paramsSerializer: function(params) {
					return qs.stringify(params);
				}
			}).then(res => {
				this.ourWork = res.data.records[0];
			}).finally(() => {
				this.isGetWorkLoading = false;
			});
		}
	}
};
</script>
